import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { SectionSummary, FormStatusCheck, Heading, NoneValue } from '../../../core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var FORM_API = 'FORM_API';
export var MAX_EXPORT_PDF_BYTES = 30 * 1024 * 1024;
export var ExportOfflinePdfTooLargeError = /*#__PURE__*/function (_Error) {
  _inherits(ExportOfflinePdfTooLargeError, _Error);

  var _super = _createSuper(ExportOfflinePdfTooLargeError);

  function ExportOfflinePdfTooLargeError() {
    var _this;

    _classCallCheck(this, ExportOfflinePdfTooLargeError);

    _this = _super.call(this, 'The generated PDF exceeds the 30 MB limit.');
    _this.name = 'ExportOfflinePdfTooLargeError';
    return _this;
  }

  return ExportOfflinePdfTooLargeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var ExportOfflineApiError = /*#__PURE__*/function (_Error2) {
  _inherits(ExportOfflineApiError, _Error2);

  var _super2 = _createSuper(ExportOfflineApiError);

  function ExportOfflineApiError(status, message, code) {
    var _this2;

    _classCallCheck(this, ExportOfflineApiError);

    _this2 = _super2.call(this, message);

    _defineProperty(_assertThisInitialized(_this2), "code", void 0);

    _defineProperty(_assertThisInitialized(_this2), "status", void 0);

    _this2.name = 'ExportOfflineApiError';
    _this2.code = code;
    _this2.status = status;
    return _this2;
  }

  return ExportOfflineApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var getHeader = function getHeader(headers, name) {
  var _headers$name;

  var value = (_headers$name = headers[name]) !== null && _headers$name !== void 0 ? _headers$name : headers[name.toLowerCase()];
  return typeof value === 'string' ? value : null;
};

var getFileName = function getFileName(contentDisposition) {
  var _contentDisposition$m, _contentDisposition$m2, _contentDisposition$m3;

  if (!contentDisposition) return 'offline-test.pdf';
  var encodedFileName = (_contentDisposition$m = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)) === null || _contentDisposition$m === void 0 ? void 0 : _contentDisposition$m[1];

  if (encodedFileName) {
    try {
      return decodeURIComponent(encodedFileName.replace(/^"|"$/g, ''));
    } catch (_unused) {
      return 'offline-test.pdf';
    }
  }

  return ((_contentDisposition$m2 = contentDisposition.match(/filename="?([^";]+)"?/i)) === null || _contentDisposition$m2 === void 0 ? void 0 : (_contentDisposition$m3 = _contentDisposition$m2[1]) === null || _contentDisposition$m3 === void 0 ? void 0 : _contentDisposition$m3.trim()) || 'offline-test.pdf';
};

var getErrorPayload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var raw, payload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(data instanceof Blob)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return data.text();

          case 4:
            _context.t0 = _context.sent;
            _context.next = 8;
            break;

          case 7:
            _context.t0 = data;

          case 8:
            raw = _context.t0;
            payload = typeof raw === 'string' ? JSON.parse(raw) : raw;
            return _context.abrupt("return", {
              code: payload === null || payload === void 0 ? void 0 : payload.code,
              message: (payload === null || payload === void 0 ? void 0 : payload.message) || 'Could not export the PDF.'
            });

          case 13:
            _context.prev = 13;
            _context.t1 = _context["catch"](0);
            return _context.abrupt("return", {
              message: 'Could not export the PDF.'
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function getErrorPayload(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getApiErrorResponse = function getApiErrorResponse(error) {
  if (!error || typeof error !== 'object' || !('response' in error)) return null;
  return error.response || null;
};

var toError = function toError(error) {
  return error instanceof Error ? error : new Error('Could not export the PDF.');
};

export var FormApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(FormApi, _AxiosApi);

  var _super3 = _createSuper(FormApi);

  function FormApi(axiosInstance, sectionApiMapper, formApiMapper, formSummaryApiMapper) {
    var _this3;

    var planClient = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : axiosInstance;

    _classCallCheck(this, FormApi);

    _this3 = _super3.call(this, 'forms', axiosInstance);
    _this3.axiosInstance = axiosInstance;
    _this3.sectionApiMapper = sectionApiMapper;
    _this3.formApiMapper = formApiMapper;
    _this3.formSummaryApiMapper = formSummaryApiMapper;
    _this3.planClient = planClient;
    return _this3;
  }

  _createClass(FormApi, [{
    key: "findByIds",
    value: function () {
      var _findByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formIds) {
        var url, jsonResponse, parsedResponseBody, formStatusCheckList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url);
                _context2.next = 4;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: {
                    formIds: formIds.join(',')
                  }
                });

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                formStatusCheckList = parsedResponseBody.data.map(function (data) {
                  return FormStatusCheck.fromJson(data);
                });
                return _context2.abrupt("return", Result.combineArray(formStatusCheckList));

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 10]]);
      }));

      function findByIds(_x2) {
        return _findByIds.apply(this, arguments);
      }

      return findByIds;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/").concat(input);
                _context3.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(this.formApiMapper.toDomain(parsedResponseBody.data)));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function findById(_x3) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url);
                _context4.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 9]]);
      }));

      function create(_x4) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "import",
    value: function () {
      var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var _id, _input, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id, "/import");
                _context5.next = 5;
                return this.axios.post(url, _input);

              case 5:
                jsonResponse = _context5.sent;
                parsedResponseBody = jsonResponse.data;
                return _context5.abrupt("return", Result.ok(parsedResponseBody.message));

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));

      function _import(_x5) {
        return _import2.apply(this, arguments);
      }

      return _import;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(useCaseInput) {
        var _parsedResponseBody$d, _id2, _input2, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _id2 = useCaseInput.id, _input2 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id2);
                _context6.next = 5;
                return this.axios.patch(url, _input2);

              case 5:
                jsonResponse = _context6.sent;
                parsedResponseBody = jsonResponse.data;
                return _context6.abrupt("return", Result.ok({
                  message: parsedResponseBody.message,
                  formVersion: (_parsedResponseBody$d = parsedResponseBody.data) === null || _parsedResponseBody$d === void 0 ? void 0 : _parsedResponseBody$d.formVersion
                }));

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 10]]);
      }));

      function update(_x6) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context7.next = 4;
                return this.axios["delete"](url);

              case 4:
                jsonResponse = _context7.sent;
                parsedResponseBody = jsonResponse.data;
                return _context7.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 9]]);
      }));

      function _delete(_x7) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "getSectionSummaries",
    value: function () {
      var _getSectionSummaries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(input) {
        var formId, url, jsonResponse, parsedResponseBody, sections;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                formId = input.formId;
                _context8.prev = 1;
                url = "".concat(this.url, "/").concat(formId, "/section-summary");
                _context8.next = 5;
                return this.axios.get(url);

              case 5:
                jsonResponse = _context8.sent;
                parsedResponseBody = jsonResponse.data;
                sections = parsedResponseBody.data.map(function (data) {
                  return SectionSummary.create(data);
                });
                return _context8.abrupt("return", Result.combineArray(sections));

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8["catch"](1);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 11]]);
      }));

      function getSectionSummaries(_x8) {
        return _getSectionSummaries.apply(this, arguments);
      }

      return getSectionSummaries;
    }()
  }, {
    key: "createSection",
    value: function () {
      var _createSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(section) {
        var url, payload;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                url = "".concat(this.url, "/").concat(section.formId, "/sections");
                payload = this.sectionApiMapper.fromDomain(section);
                _context9.next = 5;
                return this.axios.post(url, payload);

              case 5:
                return _context9.abrupt("return", Result.ok(section));

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 8]]);
      }));

      function createSection(_x9) {
        return _createSection.apply(this, arguments);
      }

      return createSection;
    }()
  }, {
    key: "updateSection",
    value: function () {
      var _updateSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(section) {
        var _id3, _formId, url, payload;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _id3 = section.id, _formId = section.formId;
                url = "".concat(this.url, "/").concat(_formId, "/sections/").concat(_id3);
                payload = this.sectionApiMapper.fromDomain(section);
                _context10.next = 6;
                return this.axios.patch(url, payload);

              case 6:
                return _context10.abrupt("return", Result.ok(section));

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 9]]);
      }));

      function updateSection(_x10) {
        return _updateSection.apply(this, arguments);
      }

      return updateSection;
    }()
  }, {
    key: "deleteSection",
    value: function () {
      var _deleteSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(useCaseInput) {
        var _formId2, sectionId, url;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _formId2 = useCaseInput.formId, sectionId = useCaseInput.sectionId;
                url = "".concat(this.url, "/").concat(_formId2, "/sections/").concat(sectionId);
                _context11.next = 5;
                return this.axios["delete"](url);

              case 5:
                return _context11.abrupt("return", Result.ok(sectionId));

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", ErrorResultHandler(_context11.t0));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function deleteSection(_x11) {
        return _deleteSection.apply(this, arguments);
      }

      return deleteSection;
    }()
  }, {
    key: "createHeading",
    value: function () {
      var _createHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(data) {
        var request, url, result, heading;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                request = {
                  id: data.id.toString(),
                  title: data.title,
                  sectionId: data.sectionId,
                  description: data.description,
                  nextQuestionId: data.nextQuestionId !== NoneValue ? data.nextQuestionId : undefined,
                  previousHeadingId: data.previousHeadingId !== NoneValue ? data.previousHeadingId : undefined,
                  nextHeadingId: data.nextHeadingId !== NoneValue ? data.nextHeadingId : undefined,
                  previousQuestionId: data.previousQuestionId !== NoneValue ? data.previousQuestionId : undefined,
                  formId: data.formId
                };
                url = "".concat(this.url, "/").concat(data.formId, "/headings");
                _context12.next = 5;
                return this.axios.post(url, request);

              case 5:
                result = _context12.sent;
                heading = Heading.create(_objectSpread({}, result.data.data), result.data.data.id).getValue();
                return _context12.abrupt("return", Result.ok(heading));

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", ErrorResultHandler(_context12.t0));

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 10]]);
      }));

      function createHeading(_x12) {
        return _createHeading.apply(this, arguments);
      }

      return createHeading;
    }()
  }, {
    key: "updateHeading",
    value: function () {
      var _updateHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var data, url, resultOrError, heading;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                data = input.data;
                url = "".concat(this.url, "/").concat(data.formId, "/headings/").concat(data.headingId);
                _context13.next = 5;
                return this.axios.patch(url, {
                  title: data.title,
                  description: data.description
                });

              case 5:
                resultOrError = _context13.sent;
                heading = Heading.create(_objectSpread({}, resultOrError.data.data), resultOrError.data.data.id).getValue();
                return _context13.abrupt("return", Result.ok(heading));

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", ErrorResultHandler(_context13.t0));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 10]]);
      }));

      function updateHeading(_x13) {
        return _updateHeading.apply(this, arguments);
      }

      return updateHeading;
    }()
  }, {
    key: "deleteHeading",
    value: function () {
      var _deleteHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        var _id4, _formId3, url, responseOrError;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _id4 = input.id, _formId3 = input.formId;
                url = "".concat(this.url, "/").concat(_formId3, "/headings/").concat(_id4.toString());
                _context14.next = 5;
                return this.axios["delete"](url);

              case 5:
                responseOrError = _context14.sent;
                return _context14.abrupt("return", Result.ok(responseOrError.data.data.id.value));

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", ErrorResultHandler(_context14.t0));

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 9]]);
      }));

      function deleteHeading(_x14) {
        return _deleteHeading.apply(this, arguments);
      }

      return deleteHeading;
    }()
  }, {
    key: "moveHeading",
    value: function () {
      var _moveHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(formId, headingId, dto) {
        var url;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                url = "".concat(this.url, "/").concat(formId, "/headings/").concat(headingId, "/move");
                _context15.next = 4;
                return this.axios.patch(url, dto);

              case 4:
                return _context15.abrupt("return", Result.ok());

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", ErrorResultHandler(_context15.t0));

              case 10:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 7]]);
      }));

      function moveHeading(_x15, _x16, _x17) {
        return _moveHeading.apply(this, arguments);
      }

      return moveHeading;
    }()
  }, {
    key: "exportOffline",
    value: function () {
      var _exportOffline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(input) {
        var body, css, formId, isShowWatermark, title, payload, response, headers, contentType, contentLength, pdf, _response, _yield$getErrorPayloa, code, message;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                body = input.body, css = input.css, formId = input.formId, isShowWatermark = input.isShowWatermark, title = input.title;
                payload = {
                  body: body,
                  css: css,
                  title: title,
                  isShowWatermark: isShowWatermark
                };

                if (!(new Blob([JSON.stringify(payload)]).size > MAX_EXPORT_PDF_BYTES)) {
                  _context16.next = 4;
                  break;
                }

                return _context16.abrupt("return", Result.fail(new ExportOfflinePdfTooLargeError()));

              case 4:
                _context16.prev = 4;
                _context16.next = 7;
                return this.axios.post("".concat(this.url, "/").concat(encodeURIComponent(formId), "/export-offline"), payload, {
                  responseType: 'blob'
                });

              case 7:
                response = _context16.sent;
                headers = response.headers;
                contentType = getHeader(headers, 'content-type') || '';

                if (contentType.toLowerCase().includes('application/pdf')) {
                  _context16.next = 12;
                  break;
                }

                return _context16.abrupt("return", Result.fail(new ExportOfflineApiError(response.status, 'The export response is not a PDF.')));

              case 12:
                contentLength = Number(getHeader(headers, 'content-length'));
                pdf = new Blob([response.data], {
                  type: 'application/pdf'
                });

                if (!(Number.isFinite(contentLength) && contentLength > MAX_EXPORT_PDF_BYTES || pdf.size > MAX_EXPORT_PDF_BYTES)) {
                  _context16.next = 16;
                  break;
                }

                return _context16.abrupt("return", Result.fail(new ExportOfflinePdfTooLargeError()));

              case 16:
                return _context16.abrupt("return", Result.ok({
                  fileName: getFileName(getHeader(headers, 'content-disposition')),
                  pdf: pdf
                }));

              case 19:
                _context16.prev = 19;
                _context16.t0 = _context16["catch"](4);
                _response = getApiErrorResponse(_context16.t0);

                if (_response) {
                  _context16.next = 24;
                  break;
                }

                return _context16.abrupt("return", Result.fail(toError(_context16.t0)));

              case 24:
                if (!(_response.status === 413)) {
                  _context16.next = 26;
                  break;
                }

                return _context16.abrupt("return", Result.fail(new ExportOfflinePdfTooLargeError()));

              case 26:
                _context16.next = 28;
                return getErrorPayload(_response.data);

              case 28:
                _yield$getErrorPayloa = _context16.sent;
                code = _yield$getErrorPayloa.code;
                message = _yield$getErrorPayloa.message;
                return _context16.abrupt("return", Result.fail(new ExportOfflineApiError(_response.status || 0, message || 'Could not export the PDF.', code)));

              case 32:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[4, 19]]);
      }));

      function exportOffline(_x18) {
        return _exportOffline.apply(this, arguments);
      }

      return exportOffline;
    }()
  }, {
    key: "getOfflineExportPlan",
    value: function () {
      var _getOfflineExportPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(input) {
        var _response$data, response, _response2, _yield$getErrorPayloa2, code, message;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return this.planClient.get('/bricks/api/export-offline/plan');

              case 3:
                response = _context17.sent;
                return _context17.abrupt("return", Result.ok({
                  requestId: input.requestId,
                  showWatermark: ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.showWatermark) !== false
                }));

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17["catch"](0);
                _response2 = getApiErrorResponse(_context17.t0);

                if (_response2) {
                  _context17.next = 12;
                  break;
                }

                return _context17.abrupt("return", Result.fail(toError(_context17.t0)));

              case 12:
                _context17.next = 14;
                return getErrorPayload(_response2.data);

              case 14:
                _yield$getErrorPayloa2 = _context17.sent;
                code = _yield$getErrorPayloa2.code;
                message = _yield$getErrorPayloa2.message;
                return _context17.abrupt("return", Result.fail(new ExportOfflineApiError(_response2.status || 0, message || 'Could not verify the current subscription.', code)));

              case 18:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 7]]);
      }));

      function getOfflineExportPlan(_x19) {
        return _getOfflineExportPlan.apply(this, arguments);
      }

      return getOfflineExportPlan;
    }()
  }, {
    key: "advancedSearch",
    value: function () {
      var _advancedSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(input) {
        var _input$tagIds,
            _parsedResponseBody$d2,
            _this4 = this;

        var jsonResponse, parsedResponseBody, forms;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.axios.get(this.url, {
                  params: _objectSpread({
                    createdBy: input === null || input === void 0 ? void 0 : input.createdBy,
                    categoryId: input === null || input === void 0 ? void 0 : input.categoryId,
                    nextToken: input === null || input === void 0 ? void 0 : input.nextToken,
                    limit: input === null || input === void 0 ? void 0 : input.limit,
                    search: input === null || input === void 0 ? void 0 : input.search
                  }, (input === null || input === void 0 ? void 0 : (_input$tagIds = input.tagIds) === null || _input$tagIds === void 0 ? void 0 : _input$tagIds.length) > 0 && {
                    tags: input === null || input === void 0 ? void 0 : input.tagIds.join(',')
                  })
                });

              case 2:
                jsonResponse = _context18.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context18.next = 6;
                  break;
                }

                return _context18.abrupt("return", Result.fail(parsedResponseBody.message));

              case 6:
                forms = (_parsedResponseBody$d2 = parsedResponseBody.data) === null || _parsedResponseBody$d2 === void 0 ? void 0 : _parsedResponseBody$d2.items.map(function (form) {
                  return _this4.formSummaryApiMapper.toDomain(form);
                });
                return _context18.abrupt("return", Result.ok({
                  forms: forms,
                  nextToken: parsedResponseBody.data.nextToken
                }));

              case 8:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function advancedSearch(_x20) {
        return _advancedSearch.apply(this, arguments);
      }

      return advancedSearch;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(input) {
        var url, request, jsonResponse, parsedResponseBody, clonedForm;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                url = "".concat(this.url, "/").concat(input.originalFormId, "/clone");
                request = {
                  id: input.id,
                  type: input.type
                };
                _context19.next = 5;
                return this.axios.post(url, request);

              case 5:
                jsonResponse = _context19.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context19.next = 9;
                  break;
                }

                return _context19.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                clonedForm = this.formApiMapper.toDomain(parsedResponseBody.data);
                return _context19.abrupt("return", Result.ok(clonedForm));

              case 13:
                _context19.prev = 13;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", ErrorResultHandler(_context19.t0));

              case 16:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 13]]);
      }));

      function clone(_x21) {
        return _clone.apply(this, arguments);
      }

      return clone;
    }()
  }]);

  return FormApi;
}(AxiosApi);